/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ trialDays: NonNullable<unknown> }} Premium_Cancel_BeforeInputs */

const en_premium_cancel_before = /** @type {(inputs: Premium_Cancel_BeforeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`If you cancel before ${i?.trialDays} days you will not be charged`)
};

const es_premium_cancel_before = /** @type {(inputs: Premium_Cancel_BeforeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Si cancelas antes de ${i?.trialDays} días no se te cobrará`)
};

/**
* | output |
* | --- |
* | "If you cancel before {trialDays} days you will not be charged" |
*
* @param {Premium_Cancel_BeforeInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const premium_cancel_before = /** @type {((inputs: Premium_Cancel_BeforeInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Premium_Cancel_BeforeInputs, { locale?: "en" | "es" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_premium_cancel_before(inputs)
	return en_premium_cancel_before(inputs)
});